import Header from '../../organisms/Header/Header'
import { Cards, Button } from 'ams-ui-reactkit';
import { Typography } from "@material-ui/core";
import { WeareSorry } from '../../assets/images';
import DynamicHtml from "../../molecules/DynamicHtml"
import './ErrorLayout.scss'

const ErrorLayout = (props: any) => {
    const { templateProps } = props;
    const showCloseBtnFlag = process.env.REACT_APP_SHOW_CLOSE_ON_LAST_PAGE ? process.env.REACT_APP_SHOW_CLOSE_ON_LAST_PAGE === "true" : false


    const isBackNav = () => {
        return false;
    };

    const showCloseButton = () => {

        if (showCloseBtnFlag) {

            return <div className={`staticFixedButton mt-8 in-active-btn-error`}>
                <Button
                    text="Close"
                    onClick={() => {
                        window.location.href = "/close";
                    }}
                    color="primary"
                    variant="contained"
                    size="large"
                />
            </div>
        }

        return null;

    }

    return (
        <div className='full-block'>
            <Header backNav={isBackNav()} progressValue={0} />
            <div className="outlineContainer">
                <div className="baseContainerBlock movewithUsBlock">
                    <Cards variant="primary">
                        <div className="thankyoumainblock">
                            <div className='pdf-download-img'>
                                <img src={WeareSorry} alt="" />
                            </div>
                            <Typography variant="body1" component="span" className="thankyoudesc">
                                <DynamicHtml content={templateProps?.script} />
                            </Typography>
                        </div>
                    </Cards>
                    {showCloseButton()}
                </div>
            </div>
        </div>
    )
}

export default ErrorLayout
